import React from "react";
import { List } from "../modules/ReimbursementsReconciliation";

export function ReimbursementsRec(props) {
  return <List {...props} />;
}
